<template>
  <div class="container-project-board flex-column">
    <!-- <div class="project-board-scroll-x"> -->
    <div class="row" v-show="selectedStories.length">
      <div class="col">
        <button class="btn btn-sm btn-primary" @click="assignStories()">Assign</button>
      </div>
    </div>
    <div class="row row-headings g-0 w-100 mt-1">
      <div class="col">
        <div class="story-heading default">
          Backlog
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Amount of user stories"
            class="count"
            data-bs-original-title="Total count"
          >
            {{ getBacklogByFilters().length }}
          </span>
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Sum of user story estimates"
            class="count"
            data-bs-original-title="Sum of user story estimates"
          >
            {{ backlog.reduce((prev, next) => prev + next.quoted_estimate, 0) | toHoursMinutes }}
          </span>
          <add-story :saveUserStory="saveUserStory" class="user-story-add"></add-story>
        </div>
      </div>
      <div class="col">
        <div class="story-heading default">
          {{ sprint.title }}
          <span data-bs-toggle="tooltip" data-bs-placement="top" title="" class="count" data-bs-original-title="Unknown">
            {{ getByFilters().length }}
          </span>
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Sum of user story estimates"
            class="count"
            data-bs-original-title="Sum of user story estimates"
          >
            {{ stories.reduce((prev, next) => prev + next.quoted_estimate, 0) | toHoursMinutes }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="loaded">
      <div class="epic" v-for="epic in activeEpics" :key="epic.id">
        <div
          v-collapse="'#collapseEpic' + epic.id"
          class="row pb-epic-heading"
          aria-expanded="false"
        >
          <div class="col">
            <i class="far fa-fw fa-chevron-down"></i>
            {{ epic.title }}
          </div>
          <div class="col">
            {{ epic.title }}
          </div>
        </div>

        <div v-bind:id="'collapseEpic' + epic.id" class="collapse show">
          <div class="row row-user-story g-0">
            <div
              class="col droppable"
              @drop="dragUnAssign(epic.id, 'New', $event)"
              @dragover.prevent
              @dragenter="dragEnter($event)"
              @dragleave="dragLeave($event)"
            >
              <story
                v-for="story in getBacklogByEpicId(epic.id)"
                :key="story.id"
                :story="story"
                selectable
                dragable
                @selected="storySelected"
                :update="updateBacklogUserStory"
              ></story>
            </div>
            <div
              class="col droppable"
              @drop="dragAssign(epic.id, 'New', $event)"
              @dragover.prevent
              @dragenter="dragEnter($event)"
              @dragleave="dragLeave($event)"
            >
              <story v-for="story in getByEpicIdAndFilters(epic.id)" :key="story.id" :story="story" dragable></story>
            </div>
          </div>
        </div>
      </div>

      <div class="epic" :key="-1">
        <div
          v-collapse="'#collapseEpic' + -1"
          class="pb-epic-heading"
          aria-expanded="false"
        >
          <i class="far fa-fw fa-chevron-down"></i>
          Unknown
        </div>

        <div v-bind:id="'collapseEpic' + -1" class="collapse show">
          <div class="row row-user-story g-0">
            <div
              class="col droppable"
              @drop="dragUnAssign(null, 'New', $event)"
              @dragover.prevent
              @dragenter="dragEnter($event)"
              @dragleave="dragLeave($event)"
            >
              <story
                v-for="story in getBacklogByEpicId(null)"
                :key="story.id"
                :story="story"
                selectable
                dragable
                @selected="storySelected"
              ></story>
            </div>
            <div
              class="col droppable"
              @drop="dragAssign(null, 'New', $event)"
              @dragover.prevent
              @dragenter="dragEnter($event)"
              @dragleave="dragLeave($event)"
            >
              <story v-for="story in getByEpicIdAndFilters(null)" :key="story.id" :story="story" dragable></story>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- </div> -->

    <filterDrawer ref="filtersDrawer" />
    <render-options-drawer ref="renderOptionsDrawer" />
    <doc-link-drawer ref="docLinkDrawer" />
    <router-view v-if="loaded"></router-view>
  </div>
</template>

<script>
import { http, queryString } from 'utils'
import { mapState, mapActions, mapGetters } from 'vuex'
import { echo } from 'mixins'
import boardDrawers from 'mixins/scrumboard/board-drawers'

import Story from '../scrumboard/_story'
import FilterDrawer from './FilterDrawer'
import RenderOptionsDrawer from './RenderOptionsDrawer'
import AddStory from '../scrumboard/_add-story'
import DocLinkDrawer from '../scrumboard/DocLinkDrawer'

export default {
  mixins: [echo, boardDrawers],

  props: ['userStoryDocId'],

  components: {
    Story,
    FilterDrawer,
    RenderOptionsDrawer,
    AddStory,
    DocLinkDrawer,
  },

  data: function () {
    return {
      focusStoryId: null,
      loaded: false,
      members: [],
      selectedStories: [],
    }
  },

  watch: {
    '$route.params.sprint_id'(newVal, oldVal) {
      this.loaded = false

      this.echo.leave(`channel-yodiz-${oldVal}`)

      this.$store.dispatch('yodizproject/tasks/clearData', [])
      this.$store.dispatch('yodizproject/stories/clearData', [])
      this.$store.dispatch('yodizproject/effort/clearData', [])

      this.loadSprintData(newVal).then(() => {
        this.loadStories().then(() => {
          this.joinPresenceChannel()
        })
      })
    },
  },

  created () {
    this.echoConnect()
  },

  mounted() {
    this.loadData()

    this.$bus.$on('us-doc-link', ({ storyId, userStoryDocId }) => {
      this.$refs.docLinkDrawer.open({ storyId, userStoryDocId })
    })
  },

  beforeDestroy: function () {
    this.$bus.$off('us-doc-link')
    // const channel = this.$root.pusher.unsubscribe('presence-channel-'+this.project.id);
    this.echo.leave(`channel-yodiz-${this.$route.params.sprint_id}`)
    this.echoDisconnect()

    this.$store.dispatch('yodizproject/tasks/clearData', [])
    this.$store.dispatch('yodizproject/stories/clearData', [])
    this.$store.dispatch('yodizproject/effort/clearData', [])
  },

  computed: {
    ...mapState('yodizproject', {
      project: 'single',
    }),

    ...mapState('yodizproject/sprints', {
      sprint: 'single',
      sprints: 'list',
    }),

    ...mapState('yodizproject/epics', {
      epics: 'list',
    }),

    ...mapState('users', ['users']),

    ...mapState('yodizproject/stories', {
      stories: 'list',
    }),

    ...mapState('yodizproject/backlog', {
      backlog: 'list',
    }),

    ...mapGetters('yodizproject/stories', {
      getStoryById: 'getById',
      getByFilters: 'getByFilters',
      getByEpicIdAndFilters: 'getByEpicIdAndFilters',
    }),

    ...mapGetters('yodizproject/backlog', {
      getBacklogStoryById: 'getById',
      getBacklogByFilters: 'getByFilters',
      getBacklogByEpicId: 'getByEpicId',
    }),

    ...mapGetters('yodizproject/tasks', {
      getCountOfStatus: 'getCountOfStatus',
    }),

    ...mapGetters('yodizproject/sprints', {
      getActiveSprint: 'getActiveSprint',
    }),

    activeEpics() {
      return this.epics.filter((epic) => {
        if (this.getByEpicIdAndFilters(epic.id).length > 0 || this.getBacklogByEpicId(epic.id).length) return true
      })
    },
  },

  methods: {
    ...mapActions('yodizproject/stories', {
      getStories: 'getList',
      updateUserStory: 'updateListObject',
      addStory: 'addFromLocalToList',
      updateStory: 'updateFromLocalToList',
      deleteStory: 'deleteFromLocalToList',
      setUserStoryListProperty: 'setSingleListProperty',
    }),

    ...mapActions('yodizproject/backlog', {
      getBacklog: 'getList',
      addToBacklog: 'addFromLocalToList',
      updateBacklogUserStory: 'updateListObject',
      storeBacklogUserStory: 'addListObject',
      removeFromBacklog: 'deleteFromLocalToList',
    }),

    ...mapActions('users', {
      getUsers: 'getUsers',
    }),

    ...mapActions('yodizuserstorydoc', {
      getUserStoryDoc: 'getSingle',
    }),

    ...mapActions('yodizproject/sprints', {
      getSprints: 'getList',
      getSprint: 'getSingle',
    }),

    ...mapActions('yodizproject/stages', {
      getStage: 'getSingle',
    }),
    ...mapActions('yodizproject/epics', {
      getEpics: 'getList',
      addEpic: 'addFromLocalToList',
    }),
    ...mapActions('yodizproject/tasks', {
      addItem: 'addFromLocalToList',
      updateItem: 'updateIfLatestVersion',
      deleteItem: 'deleteFromLocalToList',
    }),
    ...mapActions('yodizproject/effort', {
      addEffort: 'addFromLocalToList',
      updateEffort: 'updateFromLocalToList',
      deleteEffort: 'deleteFromLocalToList',
    }),

    ...mapActions('yodizproject/tags', {
      getTags: 'getList',
    }),

    connectChannels() {
    },

    joinPresenceChannel() {
      this.echo
        .join(`channel-yodiz-usd-${this.$route.params.user_story_doc_id}`)
        .listen('Yodiz.newEpicBroadcast', (data) => {
          this.addEpic([data.epic])
        })

      this.echo
        .join(`channel-yodiz-${this.sprint.id}`)
        .here((users) => {
          this.members = users
        })
        .joining((user) => {
          this.members.push(user)
        })
        .leaving((user) => {
          for (var i = 0; i <= this.members.length - 1; i++) {
            if (this.members[i].id == user.id) {
              this.members.splice(i, 1)
            }
          }
        })
        .listen('Yodiz.newStoryBroadcast', (data) => {
          this.addStory([data.story])
        })
        .listen('Yodiz.updateStoryBroadcast', (data) => {
          this.updateStory(data.story)
        })
        .listen('Yodiz.deleteStoryBroadcast', (data) => {
          this.deleteStory(data.story.id)
        })
        .listen('Yodiz.newItemBroadcast', (data) => {
          this.addItem([data.item])
        })
        .listen('Yodiz.updateItemBroadcast', (data) => {
          this.updateItem(data.item)
        })
        .listen('Yodiz.deleteItemBroadcast', (data) => {
          this.deleteItem(data.item.id)
        })
        .listen('Yodiz.newEffortBroadcast', (data) => {
          this.addEffort([data.timeEntry])
        })
        .listen('Yodiz.updateEffortBroadcast', (data) => {
          this.updateEffort(data.timeEntry)
        })
        .listen('Yodiz.deleteEffortBroadcast', (data) => {
          this.deleteEffort(data.timeEntry.id)
        })
    },

    loadStories() {
      return this.getStories().then(() => {
        //Populate the tasks from eagerloaded data
        let items = []
        let effort = []

        this.stories.forEach((item) => {
          item.tasks.forEach((task) => {
            effort = effort.concat(task.timeEntries)
            delete task.timeEntries
          })

          item.issues.forEach((issue) => {
            effort = effort.concat(issue.timeEntries)
          })

          items = items.concat(item.tasks)
          items = items.concat(item.issues)
        })

        this.$store.dispatch('yodizproject/tasks/addFromLocalToList', items).then(() => {
          this.loaded = true
        })

        this.$store.dispatch('yodizproject/effort/addFromLocalToList', effort).then(() => {})
      })
    },

    loadBacklog() {
      return this.getBacklog()
    },

    loadData() {
      this.getUsers()

      this.getUserStoryDoc(this.$route.params.user_story_doc_id).then(() => {
        this.getEpics()
        this.getSprints().then(() => {
          this.getBacklog()
          this.loadSprintData().then(() => {
            this.loadStories()
            this.joinPresenceChannel()
          })
        })
      })

      this.getTags({ area: 'scrumboard' })
    },

    getTaskCount(status) {
      //This could be improved as its currently being called for each task status
      let storyIds = this.getByFilters().map((story) => {
        return story.id
      })

      return this.getCountOfStatus(storyIds, status)
    },
    loadSprintData(sprintId = null) {
      if (!sprintId) {
        if (/^\d+$/.test(this.$route.params.sprint_id)) {
          this.activeSprintId = this.$route.params.sprint_id
        } else {
          let activeSprint = this.getActiveSprint()

          if (activeSprint) {
            this.activeSprintId = activeSprint.id
          } else {
            //default to last
            this.activeSprintId = this.sprints[this.sprints.length - 1].id
          }
        }
      } else {
        this.activeSprintId = sprintId
      }

      return this.getSprint(this.activeSprintId)
    },
    dragEnter(event) {
      event.preventDefault()

      if (event.target.classList.contains('droppable')) {
        event.target.style.backgroundColor = '#cbcbcb'
      }
    },

    dragLeave(event) {
      event.preventDefault()

      if (event.target.classList.contains('droppable')) {
        event.target.style.backgroundColor = '#cbcbcb'
      }

      event.target.style.backgroundColor = ''
    },

    dragAssign(epicId, status, event) {
      event.preventDefault()
      var userStoryId = event.dataTransfer.getData('text')
      event.target.style.backgroundColor = ''

      //Only continue if this userstory isn't already assigned (nothing to do)
      if (this.getStoryById(userStoryId)) return

      //If this userstory is already selected, remove from selected list
      if (this.selectedStories.indexOf(userStoryId))
        this.selectedStories.splice(this.selectedStories.indexOf(userStoryId), 1)

      // //Update the local state with the drop location so user sees instant feedback
      this.addStory(this.getBacklogStoryById(userStoryId))
      this.setUserStoryListProperty({ id: userStoryId, property: 'epic_id', value: epicId })
      this.setUserStoryListProperty({ id: userStoryId, property: 'sprint_id', value: this.sprint.id })
      this.removeFromBacklog(userStoryId)

      //this.setUserStoryListProperty({ id: userStoryId, property: 'last_drag', value: now })

      // //Update the server
      this.updateUserStory({ id: userStoryId, payload: { sprint_id: this.sprint.id, epic_id: epicId } })
        .then((response) => {
          //this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
        })
        .catch((response) => {
          notify.error('Failed to move story, please reload your browser.')
        })
    },
    dragUnAssign(epicId, status, event) {
      event.preventDefault()
      var userStoryId = event.dataTransfer.getData('text')
      event.target.style.backgroundColor = ''

      //Only continue if this userstory isn't already assigned (nothing to do)
      if (this.getBacklogStoryById(userStoryId)) return

      // //Update the local state with the drop location so user sees instant feedback
      this.setUserStoryListProperty({ id: userStoryId, property: 'epic_id', value: epicId })
      this.setUserStoryListProperty({ id: userStoryId, property: 'sprint_id', value: null })
      this.addToBacklog(this.getStoryById(userStoryId))
      this.deleteStory(userStoryId)

      //this.setUserStoryListProperty({ id: userStoryId, property: 'last_drag', value: now })

      // //Update the server
      this.updateBacklogUserStory({ id: userStoryId, payload: { sprint_id: null, epic_id: epicId } })
        .then((response) => {
          //this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
        })
        .catch((response) => {
          notify.error('Failed to move story, please reload your browser.')
        })
    },
    saveUserStory(story) {
      return this.storeBacklogUserStory({
        payload: Object.assign(story, {
          sprint_id: null,
          user_story_document_id: this.$route.params.user_story_doc_id,
          project_id: this.$route.params.project_id,
        }),
      })
    },
    /**
     * Keep an array of seleted userstories, user can toggle select / unselect
     */
    storySelected(storyId) {
      if (this.selectedStories.includes(storyId)) {
        this.selectedStories.splice(this.selectedStories.indexOf(storyId), 1)
      } else {
        this.selectedStories.push(storyId)
      }
    },
    async assignStories() {
      let payload = {
        ids: this.selectedStories,
        patch: {
          sprint_id: this.sprint.id,
        },
      }

      //store to server
      await http
        .put('batch/userstories', payload)
        .then((response) => {
          this.selectedStories = []

          if (response.data.hasOwnProperty('data')) {
            response.data.data.forEach((story) => {
              this.addStory(story)
              this.removeFromBacklog(story.id)
            })
          }
          return response
        })
        .catch(function (error) {
          if (error.response && error.response.status && error.response.status === 422) {
            let message = 'Form validation failed:<br>'

            if (error.response.data && error.response.data.errors) {
              Object.keys(error.response.data.errors).forEach((e) => {
                message = message + `<br><strong>${_.upperFirst(e)}</strong>: ${error.response.data.errors[e]}`
              })
            }

            notify.error(message)
          } else if (error.response) {
            notify.error('API Error: ' + error.response.status + ' <br> ' + error.response.statusText)
          }
        })
      //update local state with returned data
    },
  },
}
</script>

<style >
</style>
